import { render, staticRenderFns } from "./MiniTypeEdit.vue?vue&type=template&id=4aa2e42e&scoped=true"
import script from "./MiniTypeEdit.vue?vue&type=script&lang=js"
export * from "./MiniTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./MiniTypeEdit.vue?vue&type=style&index=0&id=4aa2e42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2e42e",
  null
  
)

export default component.exports